(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "6882e77810266cbaf2009b84";
              window.beaePageSetting.pageTitle = "Footer-DIY、"; 
              window.beaePageSetting.pageType = "footer";

          let js_GBQ0P766 = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-nmfv05btsection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-nmfv05bt',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-nmfv05bt');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-nmfv05bt: ', ex)
      };
    

      try {
        let argid = 'beae-6c9zzyw8block-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-6c9zzyw8',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-6c9zzyw8');
        args.el = args.els[0];
        ((M) => { var P;if(M.el){if(M.shape){const O=M.el.closest(".beae-slider-items");O&&!O.hasAttribute("data-svg")&&(O==null||O.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${M.id}" clipPathUnits="objectBoundingBox">
                                ${M.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),O.setAttribute("data-svg","true"))}let H=M.el.querySelector(".beae-image-content-position"),I,A=window.innerWidth>=768&&M.autoHover;var L=H.querySelector(".beae-img-ratio-control"),V=H.querySelector(".beae-img-comp-container"),T=H.querySelector(".beae-img-comp-container--second");if(L&&T){let O=function(z){let D=0,q;R(),A?H.onmouseover=function(W){Z(W)}:z.onmousedown=function(W){Z(W)},H.onmouseup=function(){U()},z.ontouchstart=function(W){Z(W)},H.ontouchend=function(){U()};function R(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{I=T.offsetWidth})}).observe(T),z.style.left&&parseInt(z.style.left)}function Z(W){check=!1,W.preventDefault(),W.clientX?W.clientX:W.touches[0].clientX,parseInt(z.style.left),D=1,H.onmousemove=function(X){j(X)},H.ontouchmove=function(X){j(X)}}function U(){D=0,check=!0}function j(W){if(D==0)return!1;q=G(W),q<0&&(q=0),q>100&&(q=100),F(q)}function G(W){const X=H.getBoundingClientRect(),ae=(W.changedTouches?W.changedTouches[0].clientX:W.clientX)-X.left;return Math.max(0,Math.min(100,Math.round(ae*100/I)))}function F(W){z.style.left=W+"%",T.style.clipPath=`polygon(${W}% 0%, ${W}% 100%, 100% 100%, 100% 0)`,V.style.clipPath=`polygon(0% 100%, 0% 0%, ${W}% 0%, ${W}% 100%)`}};L&&T&&O(L),window.addEventListener("resize",function(){L&&T&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{I=T.offsetWidth})}).observe(T),O(L))})}}let N=(P=M.el)==null?void 0:P.querySelector("a.beae-x-image"),E=N==null?void 0:N.getAttribute("href");N&&M.mode.value!=="builder"&&(E!=null&&E.includes("#"))&&N.addEventListener("click",H=>{let I=document.querySelector(E+","+(E==null?void 0:E.replace("#",".")));if(I)return I.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),H.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-6c9zzyw8: ', ex)
      };
    

      try {
        let argid = 'beae-4ttj01upsection-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-4ttj01up',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-4ttj01up');
        args.el = args.els[0];
        ((h) => { window.BeaeSlider&&!h.noRunJs&&window.BeaeSlider(h) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-4ttj01up: ', ex)
      };
    

      try {
        let argid = 'beae-oubbox25linkslist-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-oubbox25',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-oubbox25');
        args.el = args.els[0];
        ((f) => { const b=f.el.querySelector(".beae-linkslist-title"),C=f.el.querySelector(".beae-linkslist");b===null||C===null||b.addEventListener("click",m=>{window.matchMedia("(max-width: 767px)").matches&&C.classList.toggle("open")}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-oubbox25: ', ex)
      };
    

      try {
        let argid = 'beae-tj7scgozlinkslist-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-tj7scgoz',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-tj7scgoz');
        args.el = args.els[0];
        ((f) => { const b=f.el.querySelector(".beae-linkslist-title"),C=f.el.querySelector(".beae-linkslist");b===null||C===null||b.addEventListener("click",m=>{window.matchMedia("(max-width: 767px)").matches&&C.classList.toggle("open")}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-tj7scgoz: ', ex)
      };
    

      try {
        let argid = 'beae-d8fkm4kklinkslist-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-d8fkm4kk',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-d8fkm4kk');
        args.el = args.els[0];
        ((f) => { const b=f.el.querySelector(".beae-linkslist-title"),C=f.el.querySelector(".beae-linkslist");b===null||C===null||b.addEventListener("click",m=>{window.matchMedia("(max-width: 767px)").matches&&C.classList.toggle("open")}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-d8fkm4kk: ', ex)
      };
    

      try {
        let argid = 'beae-qjuar9jkblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-qjuar9jk',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-qjuar9jk');
        args.el = args.els[0];
        ((P) => { var I;let H=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");H==null||H.forEach(A=>{let O=A==null?void 0:A.getAttribute("href");A&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&A.addEventListener("click",z=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),z.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-qjuar9jk: ', ex)
      };
    

      try {
        let argid = 'beae-1yoml75wlc-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-1yoml75w',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-1yoml75w');
        args.el = args.els[0];
        ((y) => { let g=y.checkLive;function h(w){return{input:w.querySelector('input[name="locale_code"], input[name="country_code"]'),button:w.querySelector("button.beae-current-value"),panel:w.querySelector(".beae-country-results"),search:w.querySelector('input[name="country_filter"]'),resetButton:w.querySelector(".beae-reset-button")}}function p(w,x){const M=y.el.querySelector("form.beae-localization");x.input.value=w.currentTarget.dataset.value,M&&M.submit()}function f(w){w.button.focus(),w.panel.classList.toggle("hidden-dropdown"),w.button.setAttribute("aria-expanded",(w.button.getAttribute("aria-expanded")==="false").toString());const x=w.button.getBoundingClientRect();window.innerHeight-x.bottom<w.panel.offsetHeight?(w.panel.style.top="auto",w.panel.style.bottom="100%"):(w.panel.style.top="100%",w.panel.style.bottom="auto")}function b(w){return w.normalize("NFD").replace(/\p{Diacritic}/gu,"").toLowerCase()}function C(w,x){const M=b(x.search.value),L=w.querySelectorAll(".beae-countries li");L.length,x.resetButton.classList.toggle("hidden",!M),L.forEach(V=>{b(V.querySelector(".beae-country-name").textContent).indexOf(M)>-1?V.classList.remove("beae-hidden"):V.classList.add("beae-hidden")})}function m(w){w.code.toUpperCase()==="ENTER"&&w.preventDefault()}function v(w,x,M){w.stopPropagation(),M.search.value="",C(x,M)}function S(w,x,M){(!x.contains(w.target)||!x.contains(w.relatedTarget))&&(B(x,M),M.button.setAttribute("aria-expanded",(M.button.getAttribute("aria-expanded")==="false").toString()))}function B(w,x){x.panel.classList.add("hidden-dropdown"),x.search&&(x.search.value="",C(w,x))}function k(w){const x=h(w);g&&w.addEventListener("focusout",M=>S(M,w,x)),x.button.addEventListener("click",()=>f(x)),w.querySelectorAll(".beae-country-name").forEach(M=>M.addEventListener("click",L=>p(L,x))),x.search&&(x.search.addEventListener("keyup",()=>C(w,x)),x.search.addEventListener("keydown",m)),x.resetButton&&(x.resetButton.addEventListener("click",M=>v(M,w,x)),x.resetButton.addEventListener("mousedown",M=>M.preventDefault()))}y.el.querySelectorAll(".beae-localization").forEach(k) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-1yoml75w: ', ex)
      };
    

      try {
        let argid = 'beae-guc6waacblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-guc6waac',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-guc6waac');
        args.el = args.els[0];
        ((P) => { var I;let H=(I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a");H==null||H.forEach(A=>{let O=A==null?void 0:A.getAttribute("href");A&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&A.addEventListener("click",z=>{let D=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(D)return D.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),z.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-guc6waac: ', ex)
      };
    

      try {
        let argid = 'beae-qs9ud8oublock-image',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-qs9ud8ou',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-qs9ud8ou');
        args.el = args.els[0];
        ((M) => { var P;if(M.el){if(M.shape){const O=M.el.closest(".beae-slider-items");O&&!O.hasAttribute("data-svg")&&(O==null||O.closest(".beae-section").insertAdjacentHTML("beforeend",`
                            <svg width="0" height="0" style="height: 0px !important; width: 0px !important; opacity: 0 !important;">
                            <defs>
                                <clipPath id="shape-${M.id}" clipPathUnits="objectBoundingBox">
                                ${M.shape.clipPath}
                                </clipPath>
                            </defs>
                            </svg>
                        `),O.setAttribute("data-svg","true"))}let H=M.el.querySelector(".beae-image-content-position"),I,A=window.innerWidth>=768&&M.autoHover;var L=H.querySelector(".beae-img-ratio-control"),V=H.querySelector(".beae-img-comp-container"),T=H.querySelector(".beae-img-comp-container--second");if(L&&T){let O=function(z){let D=0,q;R(),A?H.onmouseover=function(W){Z(W)}:z.onmousedown=function(W){Z(W)},H.onmouseup=function(){U()},z.ontouchstart=function(W){Z(W)},H.ontouchend=function(){U()};function R(){new ResizeObserver(()=>{window.requestAnimationFrame(()=>{I=T.offsetWidth})}).observe(T),z.style.left&&parseInt(z.style.left)}function Z(W){check=!1,W.preventDefault(),W.clientX?W.clientX:W.touches[0].clientX,parseInt(z.style.left),D=1,H.onmousemove=function(X){j(X)},H.ontouchmove=function(X){j(X)}}function U(){D=0,check=!0}function j(W){if(D==0)return!1;q=G(W),q<0&&(q=0),q>100&&(q=100),F(q)}function G(W){const X=H.getBoundingClientRect(),ae=(W.changedTouches?W.changedTouches[0].clientX:W.clientX)-X.left;return Math.max(0,Math.min(100,Math.round(ae*100/I)))}function F(W){z.style.left=W+"%",T.style.clipPath=`polygon(${W}% 0%, ${W}% 100%, 100% 100%, 100% 0)`,V.style.clipPath=`polygon(0% 100%, 0% 0%, ${W}% 0%, ${W}% 100%)`}};L&&T&&O(L),window.addEventListener("resize",function(){L&&T&&(new ResizeObserver(()=>{window.requestAnimationFrame(()=>{I=T.offsetWidth})}).observe(T),O(L))})}}let N=(P=M.el)==null?void 0:P.querySelector("a.beae-x-image"),E=N==null?void 0:N.getAttribute("href");N&&M.mode.value!=="builder"&&(E!=null&&E.includes("#"))&&N.addEventListener("click",H=>{let I=document.querySelector(E+","+(E==null?void 0:E.replace("#",".")));if(I)return I.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),H.preventDefault(),!1}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-qs9ud8ou: ', ex)
      };
    }; if (window.BEAEBASE) {js_GBQ0P766()} else {window.BEAEPAGEJS.push(js_GBQ0P766)} })(); 